<div>
  <div class="modal-header pb-4">
    <div class="col">
      <h4 class="modal-title fw-bold" id="modal-basic-title">Create New Rate</h4>
      <span class="text-muted small">Select Freight Category</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>

  <div class="modal-body pt-3">
    <form [formGroup]="rateForm">
      <div class="wizard-step" [class.active]="currentStep === 1">
        <div class="rounded-3 p-3">
          <h6 class="fw-semibold mb-3 text-secondary">
            <i class="bi bi-grid me-2"></i> Select Category
          </h6>
          <div class="row">
            <div class="col-4" *ngFor="let cat of categoryTypeArray">
              <div
                class="border rounded p-3 hover-bg-light cursor-pointer d-flex justify-content-between align-items-center"
                [class]="(selectedCategoryID === cat.value ? 'border-secondary bg-secondary-subtle' : '')"
                (click)="onChangeCategory(cat)">
                <div>
                  <div class="fw-semibold">{{ cat.label }}</div>
                  <div class="text-muted small">{{ cat.description }}</div>
                </div>
                <i class="bi bi-check text-secondary fs-4" *ngIf="selectedCategoryID === cat.value"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="wizard-step" [class.active]="currentStep === 2">
        <div *ngIf="isLoadingDynamicFields" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2 text-muted">Loading rate fields...</p>
        </div>
        <div *ngIf="!isLoadingDynamicFields" class="row gy-3">
          <div class="rounded-3 p-3">
            <h6 class="fw-semibold mb-3 text-secondary"><i class="bi bi-geo-alt me-2"></i> Locations</h6>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label fw-semibold">Origin <span class="text-danger">*</span></label>
                <ng-select #originSelect [items]="originArray" bindLabel="label" bindValue="value" formControlName="origin_id"
                  [typeahead]="originSearchTerm$" [loading]="isLoadingOrigin"
                  (change)="onOriginSelected($event); originSelect.searchTerm = ''" placeholder="Select location">
                  <ng-template ng-typetosearch-tmp><div class="small text-muted p-2">Search origin...</div></ng-template>
                </ng-select>
                <small *ngIf="rateForm.get('origin_id')?.touched && rateForm.get('origin_id')?.invalid" class="text-danger">From is required</small>
              </div>

              <div class="col-md-6">
                <label class="form-label fw-semibold">Origin Type <span class="text-danger">*</span></label>
                <ng-select [items]="locationTypeArray" bindLabel="label" bindValue="value" formControlName="pickup_type"
                  placeholder="Select type"></ng-select>
                <small *ngIf="rateForm.get('pickup_type')?.invalid && (submitted || rateForm.get('pickup_type')?.dirty || rateForm.get('pickup_type')?.touched)" class="text-danger">Origin type is required</small>
              </div>

              <div class="col-md-6">
                <label class="form-label fw-semibold">Destination <span class="text-danger">*</span></label>
                <ng-select #destinationSelect [items]="destinationArray" bindLabel="label" bindValue="value" formControlName="destination_id"
                  [typeahead]="destinationSearchTerm$" [loading]="isLoadingDestination"
                  (change)="onDestinationSelected($event); destinationSelect.searchTerm = ''" placeholder="Select location">
                  <ng-template ng-typetosearch-tmp><div class="small text-muted p-2">Search destination...</div></ng-template>
                </ng-select>
                <small *ngIf="rateForm.get('destination_id')?.touched && rateForm.get('destination_id')?.invalid" class="text-danger">To is required</small>
              </div>

              <div class="col-md-6">
                <label class="form-label fw-semibold">Destination Type <span class="text-danger">*</span></label>
                <ng-select [items]="locationTypeArray" bindLabel="label" bindValue="value"
                  formControlName="delivery_type" placeholder="Select type"></ng-select>
                <small *ngIf="rateForm.get('delivery_type')?.invalid && (submitted || rateForm.get('delivery_type')?.dirty || rateForm.get('delivery_type')?.touched)" class="text-danger">Destination type is required</small>
              </div>
            </div>
          </div>

          <div class="rounded-3 p-3">
            <h6 class="fw-semibold mb-3 text-secondary"><i class="bi bi-truck me-2"></i> Rate Details</h6>

            <div class="row g-3 mb-3" *ngIf="selectedCategory.toLowerCase() === 'vehicle'">
              <div class="col-md-4" *ngFor="let id of dynamicFieldNames" [formGroup]="dynamicFieldsGroup">
                <label class="form-label fw-semibold">{{ dynamicFieldLabelsMap[id] }} <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text">$</span>
                  <input type="number"
                    class="form-control"
                    [class.is-invalid]="dynamicFieldsGroup.get(id)?.invalid && (submitted || dynamicFieldsGroup.get(id)?.dirty || dynamicFieldsGroup.get(id)?.touched)"
                    [formControlName]="id"
                    placeholder="Enter value"
                    step="0.01"
                    min="0" />
                </div>
                <small *ngIf="dynamicFieldsGroup.get(id)?.invalid && (submitted || dynamicFieldsGroup.get(id)?.dirty || dynamicFieldsGroup.get(id)?.touched)" class="text-danger">
                  <span *ngIf="dynamicFieldsGroup.get(id)?.errors?.['required']">This field is required</span>
                  <span *ngIf="dynamicFieldsGroup.get(id)?.errors?.['min']">Value must be 0 or greater</span>
                  <span *ngIf="dynamicFieldsGroup.get(id)?.errors?.['pattern']">Invalid format</span>
                </small>
              </div>
            </div>

            <div class="row g-3 mb-3" *ngIf="selectedCategory.toLowerCase() === 'pallet'">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="fw-semibold mb-0">Weight Ranges & Rates <span class="text-danger">*</span></h6>
                <button type="button"
                  *ngIf="!hasConfiguredRanges || (hasConfiguredRanges && palletFields.length < configuredRanges.length)"
                  (click)="addPalletField()"
                  class="btn btn-sm btn-secondary text-white">
                  <i class="bi bi-plus-lg me-1"></i> Add Range
                </button>
              </div>
              <div class="px-3 d-flex flex-column gap-2 bg-gray rounded overflow-auto" style="max-height: 350px;">
                <div class="row align-items-center border rounded p-3 mb-2 bg-white" *ngFor="let field of palletFields; let i = index" [formGroup]="field">
                  <div class="col-md-3">
                    <input type="number"
                      class="form-control"
                      [class.is-invalid]="field.get('range_from')?.invalid && (submitted || field.get('range_from')?.dirty || field.get('range_from')?.touched)"
                      formControlName="range_from"
                      [readonly]="hasConfiguredRanges"
                      min="0" />
                    <small *ngIf="field.get('range_from')?.invalid && (submitted || field.get('range_from')?.dirty || field.get('range_from')?.touched)" class="text-danger d-block">
                      <span *ngIf="field.get('range_from')?.errors?.['required']">Required</span>
                      <span *ngIf="field.get('range_from')?.errors?.['min']">Must be ≥ 0</span>
                    </small>
                  </div>
                  <div class="col-auto fw-bold">-</div>
                  <div class="col-md-3">
                    <input type="number"
                      class="form-control"
                      [class.is-invalid]="field.get('range_to')?.invalid && (submitted || field.get('range_to')?.dirty || field.get('range_to')?.touched)"
                      formControlName="range_to"
                      [readonly]="hasConfiguredRanges"
                      min="0" />
                    <small *ngIf="field.get('range_to')?.invalid && (submitted || field.get('range_to')?.dirty || field.get('range_to')?.touched)" class="text-danger d-block">
                      <span *ngIf="field.get('range_to')?.errors?.['required']">Required</span>
                      <span *ngIf="field.get('range_to')?.errors?.['min']">Must be ≥ 0</span>
                    </small>
                  </div>
                  <div class="col-auto">{{ field.get('unit')?.value }}</div>
                  <div class="col-auto fw-bold">$</div>
                  <div class="col-md-3">
                    <input type="number"
                      class="form-control"
                      [class.is-invalid]="field.get('bracket_rate')?.invalid && (submitted || field.get('bracket_rate')?.dirty || field.get('bracket_rate')?.touched)"
                      formControlName="bracket_rate"
                      placeholder="0.00"
                      min="0"
                      step="0.01" />
                    <small *ngIf="field.get('bracket_rate')?.invalid && (submitted || field.get('bracket_rate')?.dirty || field.get('bracket_rate')?.touched)" class="text-danger d-block">
                      <span *ngIf="field.get('bracket_rate')?.errors?.['required']">Required</span>
                      <span *ngIf="field.get('bracket_rate')?.errors?.['min']">Must be ≥ 0</span>
                    </small>
                  </div>
                    <div class="col-auto">
                        <button class="btn btn-sm btn-outline-danger border-0"
                        (click)="removePalletField(i)"
                        [disabled]="palletFields.length <= 1"
                        *ngIf="!hasConfiguredRanges || i === palletFields.length - 1">
                        <i class="bi bi-trash"></i>
                        </button>
                    </div>
                </div>
              </div>
            </div>

            <div class="row g-3 mb-3" *ngIf="selectedCategory.toLowerCase() === 'furniture'">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="fw-semibold mb-0">Weight Ranges & Rates <span class="text-danger">*</span></h6>
                <button type="button"
                  *ngIf="!hasConfiguredRanges || (hasConfiguredRanges && furnitureFields.length < configuredRanges.length)"
                  (click)="addFurnitureField()"
                  class="btn btn-sm btn-secondary text-white">
                  <i class="bi bi-plus-lg me-1"></i> Add Range
                </button>
              </div>
              <div class="px-3 d-flex flex-column gap-2 bg-gray rounded overflow-auto" style="max-height: 350px;">
                <div class="row align-items-center border rounded p-3 mb-2 bg-white" *ngFor="let field of furnitureFields; let i = index" [formGroup]="field">
                  <div class="col-md-3">
                    <input type="number"
                      class="form-control"
                      [class.is-invalid]="field.get('range_from')?.invalid && (submitted || field.get('range_from')?.dirty || field.get('range_from')?.touched)"
                      formControlName="range_from"
                      [readonly]="hasConfiguredRanges"
                      min="0" />
                    <small *ngIf="field.get('range_from')?.invalid && (submitted || field.get('range_from')?.dirty || field.get('range_from')?.touched)" class="text-danger d-block">
                      <span *ngIf="field.get('range_from')?.errors?.['required']">Required</span>
                      <span *ngIf="field.get('range_from')?.errors?.['min']">Must be ≥ 0</span>
                    </small>
                  </div>
                  <div class="col-auto fw-bold">-</div>
                  <div class="col-md-3">
                    <input type="number"
                      class="form-control"
                      [class.is-invalid]="field.get('range_to')?.invalid && (submitted || field.get('range_to')?.dirty || field.get('range_to')?.touched)"
                      formControlName="range_to"
                      [readonly]="hasConfiguredRanges"
                      min="0" />
                    <small *ngIf="field.get('range_to')?.invalid && (submitted || field.get('range_to')?.dirty || field.get('range_to')?.touched)" class="text-danger d-block">
                      <span *ngIf="field.get('range_to')?.errors?.['required']">Required</span>
                      <span *ngIf="field.get('range_to')?.errors?.['min']">Must be ≥ 0</span>
                    </small>
                  </div>
                  <div class="col-auto">{{ field.get('unit')?.value }}</div>
                  <div class="col-auto fw-bold">$</div>
                  <div class="col-md-3">
                    <input type="number"
                      class="form-control"
                      [class.is-invalid]="field.get('bracket_rate')?.invalid && (submitted || field.get('bracket_rate')?.dirty || field.get('bracket_rate')?.touched)"
                      formControlName="bracket_rate"
                      placeholder="0.00"
                      min="0"
                      step="0.01" />
                    <small *ngIf="field.get('bracket_rate')?.invalid && (submitted || field.get('bracket_rate')?.dirty || field.get('bracket_rate')?.touched)" class="text-danger d-block">
                      <span *ngIf="field.get('bracket_rate')?.errors?.['required']">Required</span>
                      <span *ngIf="field.get('bracket_rate')?.errors?.['min']">Must be ≥ 0</span>
                    </small>
                  </div>
                  <div class="col-auto">
                    <button class="btn btn-sm btn-outline-danger border-0"
                      (click)="removeFurnitureField(i)"
                      [disabled]="furnitureFields.length <= 1"
                      *ngIf="!hasConfiguredRanges || i === furnitureFields.length - 1">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label class="form-label fw-semibold">Transit Days <span class="text-danger">*</span></label>
                <input type="number"
                  class="form-control"
                  [class.is-invalid]="rateForm.get('transit_days')?.invalid && (submitted || rateForm.get('transit_days')?.dirty || rateForm.get('transit_days')?.touched)"
                  formControlName="transit_days"
                  placeholder="0"
                  min="0" />
                <small *ngIf="rateForm.get('transit_days')?.invalid && (submitted || rateForm.get('transit_days')?.dirty || rateForm.get('transit_days')?.touched)" class="text-danger">
                  <span *ngIf="rateForm.get('transit_days')?.errors?.['required']">Transit days is required</span>
                  <span *ngIf="rateForm.get('transit_days')?.errors?.['min']">Value must be 0 or greater</span>
                  <span *ngIf="rateForm.get('transit_days')?.errors?.['pattern']">Must be a whole number</span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="currentStep != 1" class="d-flex align-items-start bg-info-subtle border border-info-subtle rounded p-4 gap-3 w-100 mt-4">
      <div class="flex-grow-1 text-small">
        <span class="fw-bold">Category:</span> {{selectedCategory}}
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-between">
    <button class="btn btn-light" (click)="closeModal()">Cancel</button>
    <div class="d-flex flex-row gap-4">
      <button class="btn btn-primary" *ngIf="currentStep != 1" (click)="goToPrevStep()">Prev</button>
      <button class="btn btn-secondary text-white" *ngIf="!isSaveButtonEnabled" [disabled]="!selectedCategoryID || isLoadingDynamicFields" (click)="goToNextStep()">
        <span *ngIf="!isLoadingDynamicFields">Next</span>
        <span *ngIf="isLoadingDynamicFields">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Loading...
        </span>
      </button>
      <button class="btn btn-secondary text-white" *ngIf="isSaveButtonEnabled" (click)="handleSubmitRate()">Submit</button>
    </div>
  </div>
</div>
